import React from 'react';
import { buildPaginationPages } from '../utils/pagination';

const Pagination = ({ currentPage, totalPages, handlePageChange }) => {
  if (totalPages <= 1) {
    return null;
  }

  const pages = buildPaginationPages({
    currentPage,
    totalPages,
    maxVisiblePages: totalPages, // показываем все страницы, как и раньше
    showEdges: false,
    withEllipsis: false,
  });

  return (
    <div className="pagination">
      <button
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="pagination-button"
      >
        Назад
      </button>

      {pages.map((page) => (
        <button
          key={page}
          onClick={() => handlePageChange(page)}
          className={`pagination-button ${currentPage === page ? 'active' : ''}`}
        >
          {page}
        </button>
      ))}

      <button
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="pagination-button"
      >
        Вперед
      </button>
    </div>
  );
};

export default Pagination;
